import Icon from '../icon/icon';
import './accordion.scss'
const { useState } = require('react')

const AccordionGroup = (props) => <div className="accordion-grid">
    {props.options.map((option, i) => <Accordion key={i} {...props} {...option} />
    )}
</div>

const Accordion = (props) => {
    const [itemId, setItemId] = useState(Math.random().toString(26).slice(2));

    return (

        <article className={`accordion elevated ${props.className || ''}`} tabIndex="0">
            <input type="checkbox" name={`accordion--${props.name}`} id={`accordion--${props.name}`} tabIndex="-1" />
            <label className="header" htmlFor={`accordion--${props.name}`} style={{ padding: " var(--space-2) var(--space-4)" }}>
                <span className='label'>
                    <div style={{ display: "flex", gap: "8px", alignItems: "baseline" }}>
                        <h3 className={`text lead semibold ${props.className} `} style={{ display: "flex", gap: "var(--space-2)" }}>
                            <Icon icon={props.icon} />{props.label}
                        </h3>
                    </div>

                </span>
                <span className="notification">
                    {props.notification}
                </span>
                <span aria-label="Control" className="icon-accordion">
                    <span className="icon "
                        style={{ WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/chevron-down.svg)", maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/chevron-down.svg)", color: "currentColor" }}>
                    </span>
                </span>
            </label>
            <section className="body">
                <div className="content">
                    {props.children}
                </div>
            </section>
        </article>


    )

}


export default Accordion;